import {
  AuthenticatedRoute,
  AdminRoute,
  OnboardRoute,
  DentistRoute,
  PublicRoute,
} from './components';

export const Authenticated = 'Authenticated';
export const Admin = 'Admin';
export const Onboard = 'Onboard';
export const Dentist = 'Dentist';
export const Public = 'Public';

export const getRoute = (type) => {
  switch (type) {
    case Authenticated:
      return AuthenticatedRoute;

    case Admin:
      return AdminRoute;

    case Onboard:
      return OnboardRoute;

    case Dentist:
      return DentistRoute;

    case Public:
    default:
      return PublicRoute;
  }
};
